import React, { useEffect, useState } from 'react';
import ProcessIndicator from '../ProcessIndicator';
import { CompanyDetailsProgresses } from 'assets/helperdata/client/company-details-progress';
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import { FaSpinner } from 'react-icons/fa';
import { Skeleton } from '@mui/material';

import { useLanguage } from '../../../../contexts/LanguageContext';

// ✅ Clear
const BankDetails = () => {
	const clientUser = useSelector((state) => state.main.client);
	const [isPageLoading, setIsPageLoading] = useState(true);
	const history = useNavigate();
	const [isInProgress, setIsInProgress] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [isFormProcessing, setIsFormProcessing] = useState(false);
	const [data, setData] = useState({
		bankName: '',
		bankBeneficiary: '',
		bankIBAN: '',
		bankSWIFT: '',
		address: '',
		id: clientUser?.data?.id
	});

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		if (clientUser?.data?.id) {
			api.getClientInformationBank(clientUser?.data?.id).then((res) => {
				setIsPageLoading(false);
				if (res?.data?.companyBank) {
					setData({
						bankName: res.data?.companyBank?.bank_name,
						bankBeneficiary: res.data?.companyBank?.bank_beneficiary_name,
						bankIBAN: res.data?.companyBank?.bank_IBAN,
						bankSWIFT: res.data?.companyBank?.bank_SWIFT,
						address: res.data?.companyBank?.bank_address,
						id: res.data?.companyBank?.id
					});
				}
			});
		}
	}, [clientUser?.data?.id]);

	const moveToNext = () => {
		if (data.bankName === '' || data.bankBeneficiary === '' || data.bankIBAN === '' || data.bankSWIFT === '' || data.address === '') {

		} else {
			setIsFormProcessing(true)
			api
				.updateClientBankDetails(data.id, data)
				.then((res) => {
					setIsFormProcessing(false)
					toast.success('Bank details updated successfully');
				})
				.catch((err) => {
					setIsFormProcessing(false)
					console.log(err);
				});
		}
		setIsInProgress(false);
		history('../client/company-survey-details');
	};
	const moveToBack = () => {
		setIsInProgress(false);
		history('../client/company-documents');
	};

	const calculateCompletionPercentage = () => {
		const fields = ['bankName', 'bankBeneficiary', 'bankIBAN', 'bankSWIFT', 'address'];
		const filledFields = fields.filter((field) => data[field] !== '');
		return (filledFields.length / fields.length) * 100;
	};

	// Call this function whenever you want to get the completion percentage
	const completionPercentage = calculateCompletionPercentage();
	const { t } = useLanguage()

	return (
		<div className={`main-page-client ${isMobile ? 'padding-mobile-client' : ''}`}>
			<div className="actions-company-details-client">
				<ProcessIndicator
					isInProgress={isInProgress}
					processes={CompanyDetailsProgresses}
					currentIndex={4}
					completionPercentage={completionPercentage}
				/>
			</div>
			<div className="company-details-client-content">
				<div className="" style={{ justifyContent: 'space-between' }}>
					<table className="projectmix-table-vertical-client">
						<tbody>
							<tr>
								<td className="fw-600" colSpan={2} style={{ textAlign: isMobile ? 'left' : 'center', fontSize: isMobile ? 16 : 14 }}>
									{t('bank-details.bank-details')}
								</td>
							</tr>
							<tr>
								{!isMobile && (
									<th>
										{isPageLoading ? (
											<div>
												<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											t('bank-details.name')
										)}
									</th>
								)}
								<td>
									{isMobile && (
										isPageLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<label className="onboard-label">{t('bank-details.name')}</label>
										)
									)}
									{isPageLoading ? (
										<div style={{ padding: '4px 0' }}>
											<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<input
											type="text"
											value={data.bankName}
											className="form-control"
											onChange={(e) => {
												setData({ ...data, bankName: e.target.value });
												const completionPercentage = calculateCompletionPercentage();
											}}
										/>
									)}
								</td>
							</tr>
							<tr>
								{!isMobile && (
									<th>
										{isPageLoading ? (
											<div>
												<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											t('bank-details.beneficiary')
										)}
									</th>
								)}
								<td>
									{isMobile && (
										isPageLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<label className="onboard-label">{t('bank-details.beneficiary')}</label>
										)
									)}
									{isPageLoading ? (
										<div style={{ padding: '4px 0' }}>
											<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<input
											type="text"
											value={data.bankBeneficiary}
											className="form-control"
											onChange={(e) => {
												setData({ ...data, bankBeneficiary: e.target.value });
												const completionPercentage = calculateCompletionPercentage();
											}}
										/>
									)}
								</td>
							</tr>
							<tr>
								{!isMobile && (
									<th>
										{isPageLoading ? (
											<div>
												<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											t('bank-details.iban')
										)}
									</th>
								)}
								<td>
									{isMobile && (
										isPageLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<label className="onboard-label">{t('bank-details.iban')}</label>
										)
									)}
									{isPageLoading ? (
										<div style={{ padding: '4px 0' }}>
											<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<input
											type="text"
											value={data.bankIBAN}
											className="form-control"
											onChange={(e) => {
												setData({ ...data, bankIBAN: e.target.value });
												const completionPercentage = calculateCompletionPercentage();
											}}
										/>
									)}
								</td>
							</tr>
							<tr>
								{!isMobile && (
									<th>
										{isPageLoading ? (
											<div>
												<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											t('bank-details.swift')
										)}
									</th>
								)}
								<td>
									{isMobile && (
										isPageLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<label className="onboard-label">{t('bank-details.swift')}</label>
										)
									)}
									{isPageLoading ? (
										<div style={{ padding: '4px 0' }}>
											<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<input
											type="text"
											className="form-control"
											value={data.bankSWIFT}
											onChange={(e) => {
												setData({ ...data, bankSWIFT: e.target.value });
												const completionPercentage = calculateCompletionPercentage();
											}}
										/>
									)}
								</td>
							</tr>
							<tr>
								{!isMobile && (
									<th>
										{isPageLoading ? (
											<div>
												<Skeleton variant="rounded" width="90%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											t('bank-details.address')
										)}
									</th>
								)}
								<td>
									{isMobile && (
										isPageLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<label className="onboard-label">{t('bank-details.address')}</label>
										)
									)}
									{isPageLoading ? (
										<div style={{ padding: '4px 0' }}>
											<Skeleton variant="rounded" width="100%" height={30} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<input
											type="text"
											value={data.address}
											className="form-control"
											onChange={(e) => {
												setData({ ...data, address: e.target.value });
												const completionPercentage = calculateCompletionPercentage();
											}}
										/>
									)}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div className="action-company-dtls-adrs-btn" style={{ marginTop: 10 }}>
				{isPageLoading ? (
					<div style={{ width: '102px' }}>
						<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
					</div>
				) : (
					<button
						className={`btn btn-cmpny-dtls-action-back`}
						onClick={() => {
							if (isFormProcessing) return;
							setIsFormProcessing(true);
							setIsInProgress(true);
							moveToBack();
						}}
					>
						<MdKeyboardArrowLeft /> {t('bank-details.back')}
					</button>
				)}
				{isPageLoading ? (
					<div style={{ width: '102px' }}>
						<Skeleton variant="rounded" width="100%" height={35} style={{ borderRadius: '6' }} />
					</div>
				) : (
					<button
						className={`btn btn-cmpny-dtls-action ${isFormProcessing ? 'disabled' : ''}`}
						disabled={isFormProcessing}
						onClick={() => {
							if (isFormProcessing) return;
							setIsFormProcessing(true);
							setIsInProgress(true);
							moveToNext();
						}}
					>
						{isFormProcessing ? (
							<div>
								<FaSpinner className="spinner" style={{ height: '18px' }} /> <span style={{ marginLeft: '-7px' }}>Please wait...</span>
							</div>
						) : (
							<>
								{t('bank-details.next')} <MdKeyboardArrowRight />
							</>
						)}
					</button>
				)}
			</div>
		</div>
	);
};

export default BankDetails;
